import { FC, useEffect } from "react";
import { hotjar } from "react-hotjar";
import { useCookieConsent } from "~context/cookieConsentContext";
import { ENABLE_TRACKING_SCRIPTS } from "~features/tracking/trackingConfig";

const HOTJAR_ID = process.env.HOTJAR_PRODUCTION_ID;

export const HotjarScript: FC = () => {
  const { isAnalyticsAllowed } = useCookieConsent();

  useEffect(() => {
    if (ENABLE_TRACKING_SCRIPTS && HOTJAR_ID && isAnalyticsAllowed()) {
      hotjar.initialize((HOTJAR_ID as unknown) as number, 6);
    }
  }, [isAnalyticsAllowed]);

  return null;
};
